import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', value: 'number_index', width: '10', sortable: false },
  { text: '', value: 'select_all', align: 'center', sortable: false, width: '60' },
  { text: 'MID', value: 'mid' },
  { text: 'Nama Merchant', value: 'merchant_name' },
  { text: 'Tipe', value: 'merchant_type_alias' },
  { text: 'Nama Aggregator', value: 'aggregator_name' },
  { text: 'Kriteria Merchant', value: 'merchant_criteria' },
  { text: 'Channel Provider', value: 'channel_provider_name' },
  { text: 'Status Mapping', value: 'channel_provider_mapping_alias' },
]);

export const search = {
  mid: '',
  merchant_name: '',
  aggregator_name: '',
  merchant_criteria: '',
  channel_provider_id: '',
  channel_provider_mapping_status: '',
};

export const dataChannelProviderMappingStatus = [
  { value: '0', text: 'Belum Dimapping' },
  { value: '1', text: 'Sudah Dimapping' },
];
